<template src="./signInPage.html"></template>

<script>
import authEndpoints from '../auth.endpoints.js';
import authMixin from '../../../js/authMixin.js'

export default {
    name: 'sign-in-page',
    mixins: [authMixin],
    data() {
        return {
            dto: {},
            showForgotPassword: false,
            showResetPassword: false,
        };
    },
    methods: {
        signIn() {
            authEndpoints.signIn(this.dto.Email, this.dto.Password)
				.then((response) => {
                    return this.checkAndRouteUser(response);
				});
        },
        sendNewPassword() {
            authEndpoints.sendNewPassword(this.dto.Email)
				.then(() => {
					this.showForgotPassword = false;

					DMUtils.alertShow('Check your inbox for instructions on how to reset your password.', 'Information');
				});
        },
        resetPassword() {
            authEndpoints.resetPassword(this.dto) 
                .then(() => {
                    this.dto.Password = this.dto.NewPassword;
                    this.signIn();
                })
        },
    },
    created() {
        if (this.$route.query.confirm) {
            this.showResetPassword = true;
            this.dto.Confirm = this.$route.query.confirm;
            this.dto.Email = this.$route.query.email;
        }
    }
};
</script>
